import { useEffect, useRef, useState } from 'react';
import { db, auth, functions } from '../FirebaseAuthConfig.js';
import { doc, Timestamp, onSnapshot } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

// SVG Paths for inline icons (viewBox varies - noted where different from 260)
const SVG_PATHS = {
    // viewBox: 0 0 260 260
    dumbbell:
        'M15.48,181.516c8.722,0 15.456,-6.734 15.456,-15.316l0,-73.16c0,-8.722 -6.734,-15.456 -15.456,-15.456c-8.702,0 -15.48,6.734 -15.48,15.456l0,73.16c0,8.582 6.778,15.316 15.48,15.316Zm49.619,22.985c14.572,0 24.454,-10.134 24.454,-24.375l0,-100.951c0,-14.298 -9.882,-24.476 -24.454,-24.476c-14.559,0 -24.441,10.178 -24.441,24.476l0,100.951c0,14.241 9.882,24.375 24.441,24.375Zm34.688,-53.778l60.195,0l0,-42.246l-60.195,0l0,42.246Zm94.826,53.778c14.615,0 24.497,-10.134 24.497,-24.375l0,-100.951c0,-14.298 -9.882,-24.476 -24.497,-24.476c-14.516,0 -24.398,10.178 -24.398,24.476l0,100.951c0,14.241 9.882,24.375 24.398,24.375Zm49.107,-22.985c8.722,0 15.48,-6.734 15.48,-15.316l0,-73.16c0,-8.722 -6.757,-15.456 -15.48,-15.456c-8.722,0 -15.436,6.734 -15.436,15.456l0,73.16c0,8.582 6.714,15.316 15.436,15.316Z',
    // viewBox: 0 0 260 260
    book: 'M63.105,28.243c-24.687,0 -50.177,11.502 -60.736,29.504c-1.922,3.272 -2.368,5.328 -2.368,10.764l0,150.492c0,7.69 4.507,11.954 12.084,11.954c4.407,0 7.129,-1.357 11.656,-4.249c12.708,-9.782 29.058,-14.763 45.365,-14.763c16.346,0 31.416,5.607 42.842,15.162c1.498,1.237 3.25,1.817 4.77,1.817c2.7,0 4.908,-1.947 4.908,-4.938l0,-163.161c0,-3.102 -0.384,-4.332 -2.55,-7.478c-10.679,-15.583 -32.245,-25.104 -55.972,-25.104Zm132.992,0c-23.727,0 -45.315,9.521 -55.972,25.104c-2.165,3.146 -2.55,4.376 -2.55,7.478l0,163.161c0,2.991 2.208,4.938 4.908,4.938c1.521,0 3.273,-0.58 4.77,-1.817c11.428,-9.555 26.497,-15.162 42.778,-15.162c16.372,0 32.722,4.982 45.43,14.763c4.503,2.892 7.249,4.249 11.656,4.249c7.577,0 12.083,-4.264 12.083,-11.954l0,-150.492c0,-5.436 -0.446,-7.493 -2.368,-10.764c-10.559,-18.002 -36.049,-29.504 -60.736,-29.504Z',
    // viewBox: 0 0 260 260
    forkKnife:
        'M91.151,259.2c9.961,0 16.134,-5.74 15.997,-15.201l-2.187,-123.244c-0.073,-5.172 1.304,-7.427 5.13,-9.191c15.157,-6.944 21.906,-14.354 20.88,-35.532l-3.133,-65.636c-0.303,-5.409 -3.337,-8.659 -8.367,-8.659c-4.964,0 -7.861,3.415 -7.811,8.87l0.83,63.596c0.05,4.134 -2.355,6.549 -5.886,6.549c-3.703,0 -6.073,-2.299 -6.123,-6.273l-1.151,-65.999c-0.115,-5.193 -3.2,-8.479 -8.179,-8.479c-4.914,0 -7.999,3.286 -8.114,8.479l-1.151,65.999c-0.05,3.924 -2.47,6.273 -6.188,6.273c-3.538,0 -5.921,-2.414 -5.871,-6.549l0.793,-63.596c0.05,-5.455 -2.782,-8.87 -7.746,-8.87c-5.006,0 -8.156,3.3 -8.459,8.659l-3.133,65.636c-1.026,21.178 5.751,28.588 20.995,35.532c3.826,1.764 5.202,4.019 5.13,9.191l-2.237,123.244c-0.188,9.511 6.136,15.201 15.982,15.201Zm86.797,-96.259l-1.996,80.563c-0.271,10.006 6.136,15.696 15.959,15.696c10.033,0 16.108,-5.48 16.108,-14.834l0,-235.737c0,-5.532 -3.548,-8.63 -8.214,-8.63c-4.24,0 -7.079,2.28 -10.734,7.358c-17.821,24.911 -30.571,74.402 -30.571,117.479l0,6.614c0,8.157 2.6,13.369 9.268,17.893l4.83,3.244c3.966,2.788 5.511,5.61 5.35,10.354Z',
    // viewBox: 0 0 260 260
    moon: 'M71.839,60.026c0,-18.856 4.109,-36.961 11.127,-50.738c2.351,-6.591 -3.821,-12.409 -11.625,-7.397c-39.091,22.75 -67.243,67.238 -67.243,118.314c0,76.752 62.261,138.995 138.933,138.995c44.371,0 84.552,-21.111 109.663,-54.154c5.254,-6.793 1.433,-13.13 -6.815,-11.316c-11.206,3.38 -22.918,5.229 -35.107,5.229c-76.262,0 -138.933,-62.699 -138.933,-138.933Z',
    // viewBox: 0 0 260 260
    figureRun:
        'M154.419,52.807c14.636,0 26.415,-11.848 26.415,-26.391c0,-14.635 -11.779,-26.416 -26.415,-26.416c-14.567,0 -26.391,11.78 -26.391,26.416c0,14.543 11.824,26.391 26.391,26.391Zm-40.796,102.326l43.722,24.631l-28.08,24.035c-6.218,5.379 -6.609,12.787 -2.333,17.58c4.447,4.94 11.826,5.461 18.366,-0.117l40.411,-34.465c5.955,-5.001 4.94,-15.711 -2.162,-20.358l-43.404,-28.442l8.478,-29.723c1.036,-3.711 5.219,-4.244 7.415,-0.983l12.895,18.911c3.27,4.724 9.301,6.41 14.534,4.032l37.107,-16.563c7.024,-3.123 9.733,-9.376 6.609,-15.769c-3.046,-6.194 -9.146,-8.116 -16.034,-5.046l-28.908,12.747l-19.882,-27.496c-10.882,-14.879 -24.243,-20.77 -45.822,-19.207l-41.267,2.935c-6.849,0.493 -11.626,5.086 -12.587,12.143l-5.577,41.775c-1.055,7.672 2.86,13.187 9.828,13.948c6.955,0.639 11.509,-3.446 12.617,-11.118l4.879,-33.43l15.874,-1.148c3.371,-0.24 6.152,2.012 5.07,5.765l-9.468,33.557c-5.859,20.508 7.541,26.058 17.718,31.805Zm-78.626,101.032c5.033,4.277 12.172,4.284 18.166,-1.587l37.892,-37.546c3.387,-3.387 4.096,-4.255 6.029,-9.177l15.254,-39.457l-4.744,-2.633c-8.914,-4.97 -15.383,-9.875 -19.699,-15.26l-13.461,47.682l-39.251,39.022c-6.271,6.125 -5.526,14.27 -0.187,18.957Z',
    // viewBox: 16 -94 130 122
    heart: 'M80.747,26.52C82.672,26.52 85.47,24.946 87.967,23.285C122.614,0.693 145.409,-25.955 145.409,-52.86C145.409,-76.883 128.684,-93.287 108.33,-93.287C95.673,-93.287 86.241,-86.275 80.747,-76.003C75.29,-86.237 65.82,-93.287 53.164,-93.287C32.809,-93.287 16.084,-76.883 16.084,-52.86C16.084,-25.955 38.866,0.693 73.526,23.285C76.01,24.946 78.859,26.52 80.747,26.52Z',
    // viewBox: 12 -114 122 148
    sparkles:
        'M82.27,32.958C84.509,32.958 86.254,31.364 86.623,29.059C91.118,-4.977 95.751,-9.795 129.006,-13.458C131.391,-13.693 133.106,-15.534 133.106,-17.813C133.106,-20.101 131.42,-21.862 129.035,-22.194C95.809,-26.177 91.469,-30.636 86.623,-64.686C86.225,-67.015 84.48,-68.609 82.27,-68.609C79.994,-68.609 78.249,-67.015 77.918,-64.686C73.385,-30.636 68.752,-25.856 35.497,-22.194C33.112,-21.92 31.435,-20.131 31.435,-17.813C31.435,-15.563 33.083,-13.751 35.468,-13.458C68.629,-8.997 72.865,-4.964 77.918,29.059C78.278,31.364 80.023,32.958 82.27,32.958ZM37.656,-37.205C39.002,-37.205 40.027,-38.158 40.204,-39.504C42.452,-56.046 42.77,-56.095 60.123,-59.34C61.431,-59.546 62.407,-60.529 62.407,-61.888C62.407,-63.285 61.402,-64.284 60.094,-64.461C42.858,-66.924 42.414,-67.302 40.204,-84.23C40.027,-85.656 39.031,-86.61 37.656,-86.61C36.243,-86.61 35.247,-85.656 35.07,-84.163C32.994,-67.663 32.43,-67.668 15.151,-64.461C13.843,-64.217 12.867,-63.285 12.867,-61.888C12.867,-60.462 13.843,-59.546 15.449,-59.34C32.447,-56.642 32.994,-56.197 35.07,-39.639C35.247,-38.158 36.243,-37.205 37.656,-37.205ZM68.314,-81.912C69.263,-81.912 69.865,-82.552 70.013,-83.395C71.673,-93.448 71.568,-93.826 82.461,-95.814C83.384,-95.991 83.982,-96.577 83.982,-97.512C83.982,-98.447 83.355,-99.063 82.431,-99.21C71.568,-100.935 71.644,-101.371 70.013,-111.6C69.865,-112.51 69.263,-113.15 68.314,-113.15C67.404,-113.15 66.815,-112.51 66.668,-111.571C65.057,-101.576 65.141,-101.198 54.206,-99.21C53.296,-99.033 52.698,-98.447 52.698,-97.512C52.698,-96.577 53.296,-95.991 54.294,-95.814C65.083,-93.972 64.998,-93.565 66.668,-83.424C66.815,-82.552 67.404,-81.912 68.314,-81.912Z',
    // viewBox: 16 -110 188 150
    bubbles:
        'M123.597,-37.026C120.463,-37.026 118.088,-39.637 118.088,-42.594C118.088,-45.815 120.434,-48.278 123.597,-48.278L166.744,-48.278C169.927,-48.278 172.291,-45.844 172.291,-42.594C172.291,-39.666 169.869,-37.026 166.744,-37.026L123.597,-37.026ZM123.597,-13.366C120.463,-13.366 118.088,-15.82 118.088,-18.887C118.088,-21.961 120.434,-24.567 123.597,-24.567L154.577,-24.567C157.689,-24.567 160.082,-21.99 160.082,-18.887C160.082,-15.82 157.66,-13.366 154.577,-13.366L123.597,-13.366ZM114.513,14.536L137.122,14.536L159.296,33.579C162.989,36.751 165.288,38.166 168.276,38.166C172.568,38.166 175.14,35.181 175.14,30.459L175.14,14.536L176.476,14.536C193.475,14.536 203.302,4.784 203.302,-11.8L203.302,-50.156C203.302,-67.279 193.096,-77.394 175.542,-77.394L114.513,-77.394C96.946,-77.394 86.778,-67.279 86.778,-50.156L86.778,-11.774C86.778,4.811 96.946,14.536 114.513,14.536ZM16.084,-28.424C16.084,-9.76 27.871,1.557 45.189,1.557L47.471,1.557L47.471,19.108C47.471,23.87 50.069,26.882 54.426,26.882C57.467,26.882 59.79,25.464 63.434,22.241L81.45,6.589C78.659,1.402 77.173,-4.762 77.173,-11.774L77.173,-50.156C77.173,-72.586 91.608,-86.999 114.513,-86.999L154.415,-86.999L154.415,-88.078C151.335,-100.946 141.256,-108.528 125.982,-108.528L46.065,-108.528C27.287,-108.528 16.084,-97.224 16.084,-78.546L16.084,-28.424Z',
    // viewBox: 16 -92 134 114
    textQuote:
        'M106.922,-78.743L142.768,-78.743C146.255,-78.743 149.057,-81.469 149.057,-84.956C149.057,-88.443 146.255,-91.169 142.768,-91.169L106.922,-91.169C103.459,-91.169 100.708,-88.443 100.708,-84.956C100.708,-81.469 103.459,-78.743 106.922,-78.743ZM106.922,-45.706L142.768,-45.706C146.255,-45.706 149.057,-48.47 149.057,-51.957C149.057,-55.407 146.255,-58.171 142.768,-58.171L106.922,-58.171C103.459,-58.171 100.708,-55.407 100.708,-51.957C100.708,-48.47 103.459,-45.706 106.922,-45.706ZM22.297,-12.707L142.768,-12.707C146.255,-12.707 149.057,-15.458 149.057,-18.959C149.057,-22.408 146.255,-25.172 142.768,-25.172L22.297,-25.172C18.848,-25.172 16.084,-22.408 16.084,-18.959C16.084,-15.458 18.848,-12.707 22.297,-12.707ZM22.297,20.291L142.768,20.291C146.255,20.291 149.057,17.54 149.057,14.04C149.057,10.591 146.255,7.827 142.768,7.827L22.297,7.827C18.848,7.827 16.084,10.591 16.084,14.04C16.084,17.54 18.848,20.291 22.297,20.291ZM33.971,-42.953C42.575,-42.953 49.517,-49.072 49.517,-57.805C49.517,-66.167 43.785,-71.917 36.059,-71.917C30.967,-71.917 26.872,-69.508 24.974,-64.212L26.314,-63.465C26.694,-73.955 33.902,-81.308 44.388,-81.895C46.849,-82.059 48.735,-84.049 48.735,-86.458C48.735,-89.356 46.231,-91.207 42.984,-91.207C28.774,-91.207 16.267,-79.291 16.267,-63.031C16.267,-50.87 23.67,-42.953 33.971,-42.953ZM73.985,-42.953C82.572,-42.953 89.515,-49.072 89.515,-57.805C89.515,-66.167 83.757,-71.917 76.047,-71.917C70.952,-71.917 66.882,-69.508 64.998,-64.212L66.338,-63.465C66.666,-73.955 73.862,-81.346 84.309,-81.895C86.821,-82.059 88.737,-84.049 88.737,-86.458C88.737,-89.356 86.295,-91.207 82.986,-91.207C68.784,-91.207 56.24,-79.291 56.24,-63.031C56.24,-50.87 63.672,-42.953 73.985,-42.953Z',
    // viewBox: 16 -90 190 110
    laptop: 'M16.084,9.99C16.084,14.811 20.051,18.762 24.834,18.762L196.162,18.762C200.969,18.762 204.912,14.811 204.912,9.99C204.912,5.145 200.969,1.194 196.162,1.194L183.365,1.194L183.365,-72.373C183.365,-83.239 177.299,-89.215 166.447,-89.215L54.549,-89.215C43.962,-89.215 37.631,-83.239 37.631,-72.373L37.631,1.194L24.834,1.194C20.051,1.194 16.084,5.145 16.084,9.99ZM52.111,1.194L52.111,-68.857C52.111,-72.927 54.049,-74.787 58.015,-74.787L162.98,-74.787C166.947,-74.787 168.923,-72.927 168.923,-68.857L168.923,1.194L52.111,1.194Z',
    // viewBox: 16 -94 240 118
    person3:
        'M96.619,21.915L174.965,21.915C185.548,21.915 189.219,18.516 189.219,12.439C189.219,-3.687 168.42,-25.818 135.811,-25.818C103.164,-25.818 82.366,-3.687 82.366,12.439C82.366,18.516 86.037,21.915 96.619,21.915ZM135.838,-36.885C149.889,-36.885 161.42,-49.209 161.42,-65.002C161.42,-80.292 149.791,-92.5 135.838,-92.5C121.885,-92.5 110.162,-80.14 110.217,-64.926C110.247,-49.209 121.749,-36.885 135.838,-36.885ZM28.135,21.945L75.256,21.945C68.321,12.604 74.682,-6.347 89.587,-18.343C82.808,-22.722 73.689,-25.976 62.568,-25.976C34.763,-25.976 16.084,-5.536 16.084,11.226C16.084,18.049 19.282,21.945 28.135,21.945ZM62.595,-35.48C74.856,-35.48 84.915,-46.234 84.915,-59.962C84.915,-73.297 74.758,-83.906 62.595,-83.906C50.469,-83.906 40.261,-73.184 40.317,-59.886C40.346,-46.234 50.371,-35.48 62.595,-35.48ZM243.351,21.945C252.205,21.945 255.402,18.049 255.402,11.226C255.402,-5.536 236.723,-25.976 208.918,-25.976C197.784,-25.976 188.678,-22.722 181.861,-18.343C196.792,-6.347 203.165,12.604 196.23,21.945L243.351,21.945ZM208.854,-35.48C221.115,-35.48 231.14,-46.234 231.17,-59.886C231.199,-73.184 221.017,-83.906 208.854,-83.906C196.728,-83.906 186.571,-73.297 186.571,-59.962C186.571,-46.234 196.63,-35.48 208.854,-35.48Z',
};

/**
 * LoggingBlock Component
 *
 * Allows users to log their daily challenge activity across four categories:
 * - WORK (1 point): Exercise OR 115+ MEPs OR 10k steps
 * - ABSTAIN (2 points): Any TWO of: No sugar, No grains, No social media
 * - RENEW (1 point): Scripture OR No devices before bed OR 7+ hours sleep
 * - BONUS (weekly): eGroup attendance + Bible Study (2 points per week max)
 *
 * Weekly Bonus Behavior:
 * - Bonus buttons stay selected for the entire week once claimed
 * - Users can unclaim from any day of the week
 * - Status indicators show whether bonuses are claimed for the current week
 */

// Challenge start date for calculating week numbers
const CHALLENGE_START_DATE = new Date('2026-01-21');

/**
 * Calculate which week of the challenge a given date falls into.
 * Week 1: Jan 21-27, Week 2: Jan 28-Feb 3, etc.
 */
function getWeekNumber(dateString) {
    const logDate = new Date(dateString);
    const diffTime = logDate - CHALLENGE_START_DATE;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return Math.floor(diffDays / 7) + 1;
}

function LoggingBlock() {
    const [currentAuthUser, setCurrentAuthUser] = useState(null);

    // Day selection
    const [selectedDay, setSelectedDay] = useState('today');
    const [disableToday, setDisableToday] = useState(false);
    const [disableYesterday, setDisableYesterday] = useState(false);

    // WORK components
    const [exerciseGlobal, setExerciseGlobal] = useState(false);
    const [mepsGlobal, setMepsGlobal] = useState(0);
    const [stepsGlobal, setStepsGlobal] = useState(0);

    // ABSTAIN components
    const [sugarGlobal, setSugarGlobal] = useState(false);
    const [grainsGlobal, setGrainsGlobal] = useState(false);
    const [socialsGlobal, setSocialsGlobal] = useState(false);

    // RENEW components
    const [scriptureGlobal, setScriptureGlobal] = useState(false);
    const [devicesGlobal, setDevicesGlobal] = useState(false);
    const [sleepGlobal, setSleepGlobal] = useState(false);

    // BONUS components
    const [eGroupGlobal, setEGroupGlobal] = useState(false);
    const [bibleStudyGlobal, setBibleStudyGlobal] = useState(false);

    // Weekly bonus tracking - which weeks have been claimed
    const [eGroupClaimedWeeks, setEGroupClaimedWeeks] = useState([]);
    const [bibleStudyClaimedWeeks, setBibleStudyClaimedWeeks] = useState([]);

    // Current week number based on selected day
    const [currentWeek, setCurrentWeek] = useState(1);

    // Previous values (for calculating point differentials when updating)
    const [firstExercise, setFirstExercise] = useState(false);
    const [firstMeps, setFirstMeps] = useState(0);
    const [firstSteps, setFirstSteps] = useState(0);
    const [firstSugar, setFirstSugar] = useState(false);
    const [firstGrains, setFirstGrains] = useState(false);
    const [firstSocials, setFirstSocials] = useState(false);
    const [firstScripture, setFirstScripture] = useState(false);
    const [firstDevices, setFirstDevices] = useState(false);
    const [firstSleep, setFirstSleep] = useState(false);
    const [firstEGroup, setFirstEGroup] = useState(false);
    const [firstBibleStudy, setFirstBibleStudy] = useState(false);

    // Form state
    const [messageGlobal, setMessageGlobal] = useState('');
    const [remainingCharacters, setRemainingCharacters] = useState(0);
    const [alreadyLogged, setAlreadyLogged] = useState(false);
    const [record, setRecord] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // Ref to track the current onSnapshot unsubscribe function
    // Prevents listener leaks when getData() is called multiple times
    const logListenerRef = useRef(null);

    // Auto-refresh at midnight
    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date().toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hourCycle: 'h12',
            });
            if (now === '12:01:00 AM') {
                window.location.reload();
            }
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    // Auth listener
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((currentUser) => {
            if (currentUser) {
                setCurrentAuthUser(currentUser);
            }
        });
        return () => unsubscribe();
    }, []);

    // Check if today is a blocked date
    useEffect(() => {
        if (!currentAuthUser) return;

        const checkDay = getDate('today');
        if (checkDay === '2026-02-20') {
            setDisableToday(true);
            setSelectedDay('yesterday');
        } else if (checkDay === '2026-01-21') {
            setDisableYesterday(true);
            setSelectedDay('today');
        }
    }, [currentAuthUser]);

    // Fetch points pool data (for weekly bonus tracking)
    useEffect(() => {
        if (!currentAuthUser) return;

        const unsubscribe = onSnapshot(doc(db, `userCollection/${currentAuthUser.uid}/challengeData/everydayWarship/pointsPool/master`), (docSnap) => {
            const data = docSnap.data();
            setEGroupClaimedWeeks(data?.eGroupClaimedWeeks || []);
            setBibleStudyClaimedWeeks(data?.bibleStudyClaimedWeeks || []);
        });

        return () => unsubscribe();
    }, [currentAuthUser]);

    // Update current week and fetch log data when day selection changes
    useEffect(() => {
        if (!currentAuthUser) return;

        // Calculate current week based on selected day
        const dateString = getDate(selectedDay);
        const weekNum = getWeekNumber(dateString);
        setCurrentWeek(weekNum);

        getData();

        // Cleanup: unsubscribe the listener when deps change or component unmounts
        return () => {
            if (logListenerRef.current) {
                logListenerRef.current();
                logListenerRef.current = null;
            }
        };
    }, [selectedDay, currentAuthUser]);

    // Update bonus button states when claimed weeks change or when week changes
    useEffect(() => {
        // If this week's bonus was claimed, show the button as selected
        // This happens even if THIS specific day's log doesn't have it
        const eGroupClaimedThisWeek = eGroupClaimedWeeks.includes(currentWeek);
        const bibleStudyClaimedThisWeek = bibleStudyClaimedWeeks.includes(currentWeek);

        // Only update if the bonus was claimed this week but not on this specific day
        // (If it was claimed on this day, the getData() function already set it)
        if (eGroupClaimedThisWeek && !firstEGroup) {
            setEGroupGlobal(true);
        }
        if (bibleStudyClaimedThisWeek && !firstBibleStudy) {
            setBibleStudyGlobal(true);
        }
    }, [eGroupClaimedWeeks, bibleStudyClaimedWeeks, currentWeek, firstEGroup, firstBibleStudy]);

    // Get log data from Firestore
    function getData() {
        // Clean up any previous listener to prevent leaks
        if (logListenerRef.current) {
            logListenerRef.current();
            logListenerRef.current = null;
        }

        const daySelection = document.getElementById('daySelection')?.value || selectedDay;
        const dateToGrab = getDate(daySelection);

        const unsubscribe = onSnapshot(doc(db, `userCollection/${currentAuthUser.uid}/challengeData/everydayWarship/logData/${dateToGrab}`), (docSnap) => {
            const data = docSnap.data();

            // Set current values for daily components
            setExerciseGlobal(data?.exercise || false);
            setMepsGlobal(data?.meps || 0);
            setStepsGlobal(data?.steps || 0);
            setSugarGlobal(data?.sugar || false);
            setGrainsGlobal(data?.grains || false);
            setSocialsGlobal(data?.socials || false);
            setScriptureGlobal(data?.scripture || false);
            setDevicesGlobal(data?.devices || false);
            setSleepGlobal(data?.sleep || false);

            // For bonus components, set based on THIS day's log
            // The useEffect above will override if claimed on a different day this week
            setEGroupGlobal(data?.eGroup || false);
            setBibleStudyGlobal(data?.bibleStudy || false);

            // Set "first" values (for calculating differentials)
            setFirstExercise(data?.exercise || false);
            setFirstMeps(data?.meps || 0);
            setFirstSteps(data?.steps || 0);
            setFirstSugar(data?.sugar || false);
            setFirstGrains(data?.grains || false);
            setFirstSocials(data?.socials || false);
            setFirstScripture(data?.scripture || false);
            setFirstDevices(data?.devices || false);
            setFirstSleep(data?.sleep || false);
            setFirstEGroup(data?.eGroup || false);
            setFirstBibleStudy(data?.bibleStudy || false);

            // Form metadata
            setMessageGlobal(data?.message || '');
            setAlreadyLogged(data?.logged || false);
            setRecord(data?.record || '');
        });

        // Store the unsubscribe function in the ref so it can be cleaned up
        logListenerRef.current = unsubscribe;
        return unsubscribe;
    }

    // Format date as YYYY-MM-DD
    function getDate(day) {
        const today = new Date();
        if (day === 'yesterday') {
            today.setDate(today.getDate() - 1);
        }
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const dayNum = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${dayNum}`;
    }

    // Handle form submission
    async function handleSubmit() {
        // Validate at least one DAILY component is selected (bonus alone doesn't count)
        // This prevents creating empty logs when bonus was already claimed earlier in the week
        const hasWorkActivity = exerciseGlobal || mepsGlobal > 0 || stepsGlobal > 0;
        const hasAbstainActivity = sugarGlobal || grainsGlobal || socialsGlobal;
        const hasRenewActivity = scriptureGlobal || devicesGlobal || sleepGlobal;

        if (!hasWorkActivity && !hasAbstainActivity && !hasRenewActivity) {
            alert('Please select at least one daily component (Work, Abstain, or Renew) to log.');
            return;
        }

        setIsLoading(true);

        const daySelection = document.getElementById('daySelection')?.value || selectedDay;
        const dateToGrab = getDate(daySelection);

        // Set timestamp
        let timeToPost;
        if (daySelection === 'today') {
            timeToPost = Timestamp.now().toDate();
        } else {
            const date = Timestamp.now().toDate();
            date.setDate(date.getDate() - 1);
            timeToPost = date;
        }

        // Build data object
        const data = {
            exercise: exerciseGlobal,
            meps: Number(mepsGlobal),
            steps: Number(stepsGlobal),
            sugar: sugarGlobal,
            grains: grainsGlobal,
            socials: socialsGlobal,
            scripture: scriptureGlobal,
            devices: devicesGlobal,
            sleep: sleepGlobal,
            eGroup: eGroupGlobal,
            bibleStudy: bibleStudyGlobal,
            message: messageGlobal,
            date: dateToGrab,
            logged: alreadyLogged,
            timestamp: timeToPost,
        };

        // Include previous values if updating existing log
        if (alreadyLogged) {
            data.record = record;
            data.exerciseTaken = firstExercise;
            data.mepsTaken = firstMeps;
            data.stepsTaken = firstSteps;
            data.sugarTaken = firstSugar;
            data.grainsTaken = firstGrains;
            data.socialsTaken = firstSocials;
            data.scriptureTaken = firstScripture;
            data.devicesTaken = firstDevices;
            data.sleepTaken = firstSleep;
            data.eGroupTaken = firstEGroup;
            data.bibleStudyTaken = firstBibleStudy;
        }

        try {
            const logData = httpsCallable(functions, 'logUserEntry');
            const result = await logData({ data });

            if (result.data.result !== 'success') {
                setIsLoading(false);
                alert('Error while logging data. Please try again later.');
            } else {
                // Mark as already logged IMMEDIATELY to prevent double-submission.
                // The button stays disabled (isLoading=true) until getData()'s
                // onSnapshot fires and confirms the update, at which point
                // setIsLoading(false) is called safely.
                setAlreadyLogged(true);
                getData();
                // Re-enable the button after a short delay to allow onSnapshot to fire.
                // This is a safety net — the backend fix (server-side log read) is the
                // primary defense against double-submission.
                setTimeout(() => setIsLoading(false), 1500);
            }
        } catch (error) {
            setIsLoading(false);
            alert('Error while logging data. Please try again later.');
            console.error(error);
        }
    }

    // Check if bonuses are claimed this week
    const eGroupClaimedThisWeek = eGroupClaimedWeeks.includes(currentWeek);
    const bibleStudyClaimedThisWeek = bibleStudyClaimedWeeks.includes(currentWeek);

    // Reusable toggle button component with inline SVG support
    const ToggleButton = ({ active, onClick, svgPath, svgViewBox = '0 0 260 260', label, claimedBadge }) => (
        <div className="relative">
            <button
                className={`w-full flex flex-col items-center justify-center p-2 rounded-xl transition-all duration-200 ${
                    active ? 'bg-[#FF671F] shadow-lg' : 'bg-white dark:bg-neutral-800 hover:bg-neutral-100 dark:hover:bg-neutral-700'
                }`}
                onClick={onClick}
            >
                {svgPath ? (
                    <svg viewBox={svgViewBox} className={`w-8 h-8 mb-1 fill-current ${active ? 'text-white' : 'text-neutral-600 dark:text-neutral-300'}`}>
                        <path d={svgPath} />
                    </svg>
                ) : (
                    <span className={`text-2xl mb-1 ${active ? 'text-white' : 'text-neutral-600 dark:text-neutral-300'}`}>{label.charAt(0)}</span>
                )}
                <span className={`text-xs font-medium text-center ${active ? 'text-white' : 'text-neutral-600 dark:text-neutral-300'}`}>{label}</span>
            </button>
            {claimedBadge && <span className="absolute -top-1 -right-1 bg-green-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full">✓</span>}
        </div>
    );

    // Section header component
    const SectionHeader = ({ title, subtitle, points, bonusStatus }) => (
        <div className="flex justify-between items-center mb-2">
            <div>
                <h3 className="font-sans text-base font-bold text-neutral-700 dark:text-neutral-200">{title}</h3>
                <p className="font-sans text-xs text-neutral-500 dark:text-neutral-400">{subtitle}</p>
            </div>
            <div className="flex items-center gap-2">
                {bonusStatus !== undefined && (
                    <span
                        className={`text-xs font-medium px-2 py-1 rounded-full ${
                            bonusStatus
                                ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
                                : 'bg-neutral-100 text-neutral-500 dark:bg-neutral-600 dark:text-neutral-400'
                        }`}
                    >
                        {bonusStatus ? `${(eGroupClaimedThisWeek ? 1 : 0) + (bibleStudyClaimedThisWeek ? 1 : 0)}/2 claimed` : '0/2 claimed'}
                    </span>
                )}
                <span className="text-xs font-semibold text-[#FF671F] bg-orange-100 dark:bg-orange-900/30 px-2 py-1 rounded-full">{points}</span>
            </div>
        </div>
    );

    return (
        <div className="w-full flex flex-col justify-start gap-4">
            <div className="w-full h-fit rounded-2xl bg-neutral-200 dark:bg-neutral-700 p-4 flex flex-col justify-start items-center gap-4">
                {/* Header with day selection */}
                <div className="w-full flex flex-row justify-between items-center">
                    <div>
                        <h2 className="font-sans text-xl font-bold text-neutral-700 dark:text-neutral-200">Log Activity</h2>
                        <p className="font-sans text-xs text-neutral-500 dark:text-neutral-400">Week {currentWeek} of challenge</p>
                    </div>
                    <select
                        className="h-9 px-3 border-none rounded-xl font-sans text-sm font-semibold text-neutral-700 bg-white dark:bg-neutral-800 dark:text-neutral-200 focus:outline focus:outline-[#FF671F] cursor-pointer"
                        id="daySelection"
                        value={selectedDay}
                        onChange={(e) => setSelectedDay(e.target.value)}
                    >
                        {!disableToday && <option value="today">Today</option>}
                        {!disableYesterday && <option value="yesterday">Yesterday</option>}
                    </select>
                </div>

                {/* ==================== WORK SECTION ==================== */}
                <div className="w-full">
                    <SectionHeader title="W - WORK" subtitle="Choose ONE" points="1 pt" />
                    <div className="grid grid-cols-3 gap-2">
                        <ToggleButton
                            active={exerciseGlobal}
                            onClick={() => setExerciseGlobal(!exerciseGlobal)}
                            svgPath={SVG_PATHS.dumbbell}
                            label="Exercise"
                        />
                        <div className="flex flex-col items-center">
                            <div
                                className={`w-full p-2 rounded-xl transition-all duration-200 ${
                                    mepsGlobal >= 115 ? 'bg-[#FF671F] shadow-lg' : 'bg-white dark:bg-neutral-800'
                                }`}
                            >
                                <label
                                    className={`text-xs font-medium flex items-center justify-center gap-1 mb-1 ${
                                        mepsGlobal >= 115 ? 'text-white' : 'text-neutral-600 dark:text-neutral-300'
                                    }`}
                                >
                                    <svg
                                        viewBox="16 -94 130 122"
                                        className={`w-4 h-4 fill-current ${mepsGlobal >= 115 ? 'text-white' : 'text-neutral-600 dark:text-neutral-300'}`}
                                    >
                                        <path d={SVG_PATHS.heart} />
                                    </svg>
                                    MEPs
                                </label>
                                <input
                                    type="number"
                                    min="0"
                                    value={mepsGlobal}
                                    onChange={(e) => setMepsGlobal(Math.max(0, parseInt(e.target.value) || 0))}
                                    className="w-full h-8 text-center border-none rounded-lg font-sans text-sm font-semibold text-neutral-700 bg-neutral-100 dark:bg-neutral-700 dark:text-neutral-200 focus:outline focus:outline-[#FF671F] appearance-none"
                                    placeholder="115+"
                                />
                            </div>
                        </div>
                        <div className="flex flex-col items-center">
                            <div
                                className={`w-full p-2 rounded-xl transition-all duration-200 ${
                                    stepsGlobal >= 10000 ? 'bg-[#FF671F] shadow-lg' : 'bg-white dark:bg-neutral-800'
                                }`}
                            >
                                <label
                                    className={`text-xs font-medium flex items-center justify-center gap-1 mb-1 ${
                                        stepsGlobal >= 10000 ? 'text-white' : 'text-neutral-600 dark:text-neutral-300'
                                    }`}
                                >
                                    <svg
                                        viewBox="0 0 260 260"
                                        className={`w-4 h-4 fill-current ${stepsGlobal >= 10000 ? 'text-white' : 'text-neutral-600 dark:text-neutral-300'}`}
                                    >
                                        <path d={SVG_PATHS.figureRun} />
                                    </svg>
                                    Steps
                                </label>
                                <input
                                    type="number"
                                    min="0"
                                    value={stepsGlobal}
                                    onChange={(e) => setStepsGlobal(Math.max(0, parseInt(e.target.value) || 0))}
                                    className="w-full h-8 text-center border-none rounded-lg font-sans text-sm font-semibold text-neutral-700 bg-neutral-100 dark:bg-neutral-700 dark:text-neutral-200 focus:outline focus:outline-[#FF671F] appearance-none"
                                    placeholder="10,000"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* ==================== ABSTAIN SECTION ==================== */}
                <div className="w-full">
                    <SectionHeader title="A - ABSTAIN" subtitle="Choose up to TWO" points="2 pts max" />
                    <div className="grid grid-cols-3 gap-2">
                        <ToggleButton
                            active={sugarGlobal}
                            onClick={() => setSugarGlobal(!sugarGlobal)}
                            svgPath={SVG_PATHS.sparkles}
                            svgViewBox="12 -114 122 148"
                            label="No Sugar"
                        />
                        <ToggleButton active={grainsGlobal} onClick={() => setGrainsGlobal(!grainsGlobal)} svgPath={SVG_PATHS.forkKnife} label="No Grains" />
                        <ToggleButton
                            active={socialsGlobal}
                            onClick={() => setSocialsGlobal(!socialsGlobal)}
                            svgPath={SVG_PATHS.bubbles}
                            svgViewBox="16 -110 188 150"
                            label="No Socials"
                        />
                    </div>
                </div>

                {/* ==================== RENEW SECTION ==================== */}
                <div className="w-full">
                    <SectionHeader title="R - RENEW" subtitle="Choose ONE" points="1 pt" />
                    <div className="grid grid-cols-3 gap-2">
                        <ToggleButton
                            active={scriptureGlobal}
                            onClick={() => setScriptureGlobal(!scriptureGlobal)}
                            svgPath={SVG_PATHS.textQuote}
                            svgViewBox="16 -92 134 114"
                            label="Scripture"
                        />
                        <ToggleButton
                            active={devicesGlobal}
                            onClick={() => setDevicesGlobal(!devicesGlobal)}
                            svgPath={SVG_PATHS.laptop}
                            svgViewBox="16 -90 190 110"
                            label="No Devices"
                        />
                        <ToggleButton active={sleepGlobal} onClick={() => setSleepGlobal(!sleepGlobal)} svgPath={SVG_PATHS.moon} label="7+ Hours" />
                    </div>
                </div>

                {/* ==================== BONUS SECTION ==================== */}
                <div className="w-full">
                    <SectionHeader
                        title="BONUS"
                        subtitle={`Week ${currentWeek} (once per week each)`}
                        points="+2 pts/wk"
                        bonusStatus={eGroupClaimedThisWeek || bibleStudyClaimedThisWeek}
                    />
                    <div className="grid grid-cols-2 gap-2">
                        <ToggleButton
                            active={eGroupGlobal}
                            onClick={() => setEGroupGlobal(!eGroupGlobal)}
                            svgPath={SVG_PATHS.person3}
                            svgViewBox="16 -94 240 118"
                            label="eGroup"
                            claimedBadge={eGroupClaimedThisWeek}
                        />
                        <ToggleButton
                            active={bibleStudyGlobal}
                            onClick={() => setBibleStudyGlobal(!bibleStudyGlobal)}
                            svgPath={SVG_PATHS.book}
                            label="Bible Study"
                            claimedBadge={bibleStudyClaimedThisWeek}
                        />
                    </div>
                </div>

                {/* ==================== MESSAGE ==================== */}
                <div className="w-full">
                    <div className="flex justify-between items-center mb-1">
                        <label className="text-xs font-medium text-neutral-600 dark:text-neutral-400">Message (Optional)</label>
                        <span className="text-xs text-neutral-500 dark:text-neutral-400">{remainingCharacters}/250</span>
                    </div>
                    <textarea
                        maxLength="250"
                        className="w-full h-16 border-none rounded-xl p-3 font-sans text-sm text-neutral-700 dark:text-neutral-200 bg-white dark:bg-neutral-800 focus:outline focus:outline-[#FF671F] resize-none"
                        value={messageGlobal}
                        placeholder="Share a quick update..."
                        onChange={(e) => {
                            setMessageGlobal(e.target.value);
                            setRemainingCharacters(e.target.value.length);
                        }}
                    />
                </div>
            </div>

            {/* ==================== SUBMIT BUTTON ==================== */}
            <button
                className={`w-full h-14 border-none rounded-2xl font-sans text-xl font-bold text-white transition-all duration-200 ${
                    isLoading ? 'bg-neutral-400 cursor-not-allowed' : 'bg-[#FF671F] hover:bg-[#e55a1a] cursor-pointer shadow-lg hover:shadow-xl'
                }`}
                onClick={handleSubmit}
                disabled={isLoading}
            >
                {isLoading ? 'LOGGING...' : alreadyLogged ? 'UPDATE LOG' : 'LOG'}
            </button>
        </div>
    );
}

export default LoggingBlock;
